import SimpleAccordion from '../../../Core/Expansion/SimpleAccordion'
import React from 'react'
import FlexView from 'react-flexview'
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService';
import {LiabilityExtensionManage} from '../PolicyDetailSections/LiabilitySection'
import PolicyLiabilityExtensionContext from '../../../../context/PolicyLiabilityExtensionContext'
import {POLICY_MODIFICATION_CONTEXT_ACTIONS, ModificationContextStore} from '../../../../context/ModificationContext'
import { liabilityLimitPretty } from '../../../../services/utils'
import { LiabilityCoveragePopover } from '../../../Core/Popover/LiabilityCoveragePopover'
import ViolationsService from '../../../../services/ViolationsService'
import { Action } from '../../../../models/Action';



export const ModifyLiabilityCoverage = ({...props}) => {
    const modificationContext = React.useContext(ModificationContextStore) 
    const [isOpen,setIsOpen] = React.useState(false)
    const [error, setError] = React.useState()
    const {insurance, modificationObject, isRenewal} = props;

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS);

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS, id)
        }
    }, [])

    React.useEffect(() => {
        let violations = ViolationsService.checkHullViolations({liabilityLimit:modificationObject.liabilityLimit}, modificationObject.drones, modificationObject.equipment)
        if(violations.error) {
            setError(violations.msg)
            modificationContext.dispatch(new Action(POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_LIABILITY_VALID, false))
        }
        else {
            setError('')
            modificationContext.dispatch(new Action(POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_LIABILITY_VALID, true))
        }
    }, [modificationObject.drones, modificationObject.equipment, modificationObject.liabilityLimit])

    return (
    <React.Fragment>
       <SimpleAccordion onClick={()=>setIsOpen(!isOpen)} isOpen={isOpen} className='margin-top-large'
       title={
       <FlexView column className="space-between full-width"> <div>Liability Coverage <LiabilityCoveragePopover carrier={insurance.carrier}/></div>
            <div className="grey text-small">{liabilityLimitPretty(modificationObject.liabilityLimit)} Liability limit/ Premium ${modificationObject.liabilityLimitPremium}</div>
       </FlexView>} 
            content={
                <FlexView column>
                    <LiabilityExtensionManage modify={true} insurance={insurance} modificationObject={modificationObject} isRenewal={isRenewal} />
                {!!error && error}</FlexView>
                }/>
    </React.Fragment>)
}